import type { IcIcon } from "./types";

export const IcSearch: IcIcon = (properties) => (
  <svg
    fill="currentColor"
    height="22"
    viewBox="0 0 22 22"
    width="22"
    {...properties}
  >
    <path d="M21.707 20.293a1 1 0 0 1-1.414 1.414l-5.42-5.42a1 1 0 0 1 1.414-1.414l5.42 5.42z" />
    <path d="M16.288 16.286A9.54 9.54 0 1 1 2.797 2.794a9.54 9.54 0 0 1 13.491 13.492zm-1.414-1.414A7.54 7.54 0 1 0 4.211 4.208a7.54 7.54 0 0 0 10.663 10.664z" />
  </svg>
);
